import React from 'react'
import Table from '../../../form/component/Table'
import VipIcon from '../../../form/component/VipIcon'
import { renderStateName } from '../../../process/util/names'
import { renderStoreNameById } from '../../../store/util/renderStoreName'
import { renderCountryName } from '../../../customer/util/names'

export default [
    {
        property: 'vip',
        header: 'VIP',
        width: '45',
        renderer: (salesOrder) => {
            return <VipIcon active={!!salesOrder.vip}/>
        },
        columnName: 'salesorder_salesorder.vip',
    },
    {
        property: 'created',
        header: 'Created',
        renderer: Table.dateTimeRenderer('created'),
        columnName: 'salesorder_salesorder.created',
    },
    {
        property: 'referenceNumber',
        header: 'No.',
        columnName: 'salesorder_salesorder.referenceNumber',
    },
    {
        property: 'firstName',
        header: 'Firstname',
        columnName: 'customer_customer.firstName',
    },
    {
        property: 'lastName',
        header: 'Lastname',
        columnName: 'customer_customer.lastName',
    },
    {
        property: 'email',
        header: 'Email',
        columnName: 'customer_customer.email',
    },
    {
        property: 'status',
        header: 'Status',
        renderer: (salesOrder) => {
            return renderStateName(salesOrder.status)
        },
        columnName: 'salesorder_salesorder.status',
    },
    {
        property: 'lastStateTransition',
        header: 'Last Status Change',
        renderer: Table.dateRenderer('lastStateTransition'),
        columnName: 'salesorder_salesorder.lastStateTransition',
    },
    {
        property: 'store',
        header: 'Store',
        renderer: (appointment) => {
            return renderStoreNameById(appointment.storeId)
        },
        columnName: 'customer_customer.store',
    },
    {
        property: 'countryCode',
        header: 'Country',
        renderer: (customer) => {
            return renderCountryName(customer.countryCode)
        },
        columnName: 'customer_customer.countryCode',
    },
]



// WEBPACK FOOTER //
// ./src/modules/sales-order/component/search/in-shop-scan-column-list.js